
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ExternalLinkIcon from 'react-icons/lib/fa/external-link';
import BookchatLogo from '../../../assets/BookChat.png';
import TrackedAnchor from './TrackedAnchor';

import './linkToBookchat.less';
/**
 * A View Component used to represent a direct link to Bookchat.
 *
 * The component is composed of an icon and arbitrary text which are customizable via optional props.
 * Uses default props to set the displayText and linkText, both of which may be modified dependent on
 * the Feature which they are included in.
 *
 * Interaction with this component is always expected to be logged, so be sure to provide the expected props
 * to satisfy the <TrackedAnchor>.
 *
 * @param {*} props
 * @returns LinkToNoveList component
 */
class LinkToBookchat extends Component {
	constructor(props) {
		super(props);
		this.anchorProps = {
			target: "_blank",
			anchorClass: 'clickable',
			featureType: props.featureType,
			srcId: props.srcId,
			destId: props.destId,
			href: props.href,
			alt: 'BookChat in NoveList',
			title: 'BookChat in NoveList'
		};
	}

	render() {
		return (
			<div className="link-to-bookchat">
				<img src={BookchatLogo} className="link-to-bookchat-logo" alt="BookChat" />
				<span>
					{this.props.displayText}
					<TrackedAnchor {...this.anchorProps} >
						<ExternalLinkIcon
							className="link-to-bookchat-external-icon"
							title="BookChat in NoveList"
							alt="BookChat in NoveList"
						/>
						{this.props.linkText}
					</TrackedAnchor>
				</span>
			</div>
		);
	}
}

LinkToBookchat.propTypes = {
	// the text that is displayed on the component
	displayText: PropTypes.string,
	linkText: PropTypes.string,
	featureType: PropTypes.object.isRequired,
	srcId: PropTypes.string.isRequired,
	destId: PropTypes.string.isRequired,
	href: PropTypes.string.isRequired,
};

LinkToBookchat.defaultProps = {
	linkText: 'BookChat Specialists',
	displayText: 'Get on-the-spot reading suggestions from',
	height: '45',
};

export default LinkToBookchat;



// WEBPACK FOOTER //
// ./src/react/views/generic/LinkToBookchat.jsx